import * as React from 'react';
import '../../../panels/panels.css';
import { Button, Label, Segment, Form, Checkbox, Dropdown, Input } from 'semantic-ui-react';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import Toast from '../../../sys/toast';
import OAuth, { OAuthClientStatus } from '../../../api';
const _ = require('lodash');

class State {
    transactionLogDetail: boolean;
    transactionLogInfo: boolean;
    transactionLogWarn: boolean;
    transactionLogErr: boolean;
    transactionLogStreamErr: boolean;
    transactionLogStreamWarn: boolean;
    transactionLogStreamInfo: boolean;
    transactionLogStreamDetails: boolean;
    assetVariants: any;
    assetFilter: any;
    traceRouteEnable: boolean;
    rvlUdpSrcPort: number;
    rvlPortOptions: any;
    rvlEthPort: number;
    rvlAudioBind: any;
    rvlTimestampInsert: boolean;
}

interface Props {

}

export default class DiagnosticsConfig extends React.Component<Props, State> {

    private transactionLogErr: any; private transactionLogWarn: any; private transactionLogInfo: any;
    private transactionLogDetail: any; private traceRouteEnable: boolean; private rvlUdpSrcPort: any;
    private rvlAudioBind: any; private rvlTimestampInsert: boolean;
    private transactionLogStreamErr: any; private transactionLogStreamWarn: any;
    private transactionLogStreamInfo: any;  private transactionLogStreamDetails: any;

    componentWillMount() {
        let assetid;
        if (window.localStorage && (assetid = window.localStorage.getItem('assetid'))) {
            assetid = parseInt(assetid, 10);
        } else {
            assetid = 0;
        }
        this.setState({
            transactionLogDetail: false,
            transactionLogInfo: false,
            transactionLogWarn: false,
            transactionLogErr: false,
            transactionLogStreamErr: false,
            transactionLogStreamWarn: false,
            transactionLogStreamInfo: false,
            transactionLogStreamDetails: false,
            traceRouteEnable: false,
            rvlUdpSrcPort: 0,
            rvlPortOptions: 0,
            rvlEthPort: -1,
            rvlAudioBind: '',
            rvlTimestampInsert: false,
            assetFilter: assetid
        });
        this.fetchData();

    }
    componentDidMount() {
        this.fetchAssetVariants();
        this.assetVariantChange(this.state.assetFilter);
    }

    assetVariantChange(value: any) {
        this.setState({
          assetFilter: value
        });
        window.localStorage.setItem('assetid', value);
        if (value === 0) {
            this.setState({
              transactionLogStreamErr: false,
              transactionLogStreamInfo: false,
              transactionLogStreamWarn: false,
              transactionLogStreamDetails: false
            });
        }
        if (!(value === 0 || value === '' || value === undefined)) {
            this.fetchStreamsData(value);
        }
    }

    fetchStreamsData(streamid: number) {
        let _this = this;
        let url = 'http://default/api/config/section/options/abr';
        axios.post(url, {
            mode: 'get',
            options: [
                {'name': 'transactionLogStreamErr', 'input': streamid},
                {'name': 'transactionLogStreamWarn', 'input': streamid},
                {'name': 'transactionLogStreamInfo', 'input': streamid},
                {'name': 'transactionLogStreamDetails', 'input': streamid}
            ]
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.section !== undefined) {
                    let responseObject = response.data.section.options;

                    _this.transactionLogStreamErr = responseObject[0].value;
                    _this.transactionLogStreamWarn = responseObject[1].value;
                    _this.transactionLogStreamInfo = responseObject[2].value;
                    _this.transactionLogStreamDetails = responseObject[3].value;

                    _this.setState({
                       transactionLogStreamErr: _this.transactionLogStreamErr,
                       transactionLogStreamInfo: _this.transactionLogStreamInfo,
                       transactionLogStreamWarn: _this.transactionLogStreamWarn,
                       transactionLogStreamDetails: _this.transactionLogStreamDetails
                    });
                } else {
                    window.localStorage.setItem('assetid', '0');
                    _this.setState({
                       transactionLogStreamErr: false,
                       transactionLogStreamInfo: false,
                       transactionLogStreamWarn: false,
                       transactionLogStreamDetails: false,
                       assetFilter: 0
                    });
                    // tslint:disable-next-line:no-console
                    console.log('expected array of streams values, got ', response.data);
                }
            })
            .catch(function (error: AxiosRequestConfig) {
                window.localStorage.setItem('assetid', '0');
                _this.setState({
                    transactionLogStreamErr: false,
                    transactionLogStreamInfo: false,
                    transactionLogStreamWarn: false,
                    transactionLogStreamDetails: false,
                    assetFilter: 0
                });
                // tslint:disable-next-line:no-console
                console.log('fetchStreamsData() error: ', error);
            });
    }

    fetchAssetVariants() {
        let _this = this;
        let url = 'http://default/api/stream/status?streams=all';
        axios.get(url)
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.streams !== undefined) {

                    let nameArr = _.map((response.data.streams), (i: any) => _.pick(i, 'name', 'streamid', 'logFilter'));

                    // Taking only name and streamid out of response
                    let assetVar = [{ value: 0, text: '----'}];

                    // tslint:disable-next-line:forin
                    for (let j in nameArr) {
                        if (nameArr[j].logFilter > 0) {
                            assetVar.push({ value: nameArr[j].streamid, text: '* ' + nameArr[j].name});
                        } else {
                            assetVar.push({ value: nameArr[j].streamid, text: nameArr[j].name});
                        }
                    }

                    _this.setState({
                       assetVariants: assetVar.sort( function( a: any, b: any ) {
                           return a.text.toLowerCase().localeCompare(b.text.toLowerCase());      // Sorting alphabetically
                       })
                   });
                } else
                // tslint:disable-next-line:no-console
                    console.log('expected array of variants, got ', response.data);
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('fetchAssetVariants() error: ', error);
            });
    }

    fetchData() {
        let _this = this;
        let url = 'http://default/api/config/section/options/abr';
        this.fetchEthernetPorts();
        axios.post(url, {
            mode: 'get',
            defaults: {
            },
            options: [
                'transactionLogErr',
                'transactionLogWarn',
                'transactionLogInfo',
                'transactionLogDetail',
                'traceRouteEnable',
                'rvlUdpSrcPort',
                'rvlAudioBind',
                'rvlTimestampInsert'
            ]
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.section !== undefined) {
                    let responseObject = response.data.section.options;
                    
                    _this.transactionLogErr = responseObject[0].value; _this.transactionLogWarn = responseObject[1].value;
                    _this.transactionLogInfo =  responseObject[2].value; _this.transactionLogDetail = responseObject[3].value;
                    _this.traceRouteEnable = responseObject[4].value; _this.rvlUdpSrcPort = responseObject[5].value;
                    _this.rvlAudioBind = responseObject[6].value; _this.rvlTimestampInsert = responseObject[7].value;

                    _this.setState({
                        transactionLogDetail: _this.transactionLogDetail,
                        transactionLogInfo: _this.transactionLogInfo,
                        transactionLogWarn: _this.transactionLogWarn,
                        transactionLogErr: _this.transactionLogErr,
                        traceRouteEnable: _this.traceRouteEnable,
                        rvlUdpSrcPort: _this.rvlUdpSrcPort,
                        rvlAudioBind: _this.rvlAudioBind,
                        rvlTimestampInsert: _this.rvlTimestampInsert
                    });
                } else
                    // tslint:disable-next-line:no-console
                    console.log('expected array of config values, got ', response.data);
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('fetchData() error: ', error);
            });

    }

    updateConfig(e: any, data: any) {
        let url = 'http://default/api/config/section/options/abr';

        let options = [];
        if (this.state.assetFilter !== undefined && this.state.assetFilter !== '' && this.state.assetFilter !== 0) {
            // If 'None' is selected for ethernet port, don't send the 'rvlEthPort' information.
            if (this.state.rvlEthPort === -1) {
                options = [
                    {
                        'name': 'transactionLogErr', 'value': this.state.transactionLogErr
                    }, {
                        'name': 'transactionLogWarn', 'value': this.state.transactionLogWarn
                    }, {
                        'name': 'transactionLogInfo', 'value': this.state.transactionLogInfo
                    }, {
                        'name': 'transactionLogDetail', 'value': this.state.transactionLogDetail
                    }, {
                        'name': 'transactionLogStreamErr',
                        'input': this.state.assetFilter,
                        'value': this.state.transactionLogStreamErr
                    }, {
                        'name': 'transactionLogStreamWarn',
                        'input': this.state.assetFilter,
                        'value': this.state.transactionLogStreamWarn
                    }, {
                        'name': 'transactionLogStreamInfo',
                        'input': this.state.assetFilter,
                        'value': this.state.transactionLogStreamInfo
                    }, {
                        'name': 'transactionLogStreamDetails',
                        'input': this.state.assetFilter,
                        'value': this.state.transactionLogStreamDetails
                    }, {
                        'name': 'traceRouteEnable', 'value': this.state.traceRouteEnable
                    }, {
                        'name': 'rvlUdpSrcPort', 'value': this.state.rvlUdpSrcPort
                    }, {
                        'name': 'rvlAudioBind', 'value': this.state.rvlAudioBind
                    }, {
                        'name': 'rvlTimestampInsert', 'value': this.state.rvlTimestampInsert
                    }
                ];
            } else {
                options = [
                    {
                        'name': 'transactionLogErr', 'value': this.state.transactionLogErr
                    }, {
                        'name': 'transactionLogWarn', 'value': this.state.transactionLogWarn
                    }, {
                        'name': 'transactionLogInfo', 'value': this.state.transactionLogInfo
                    }, {
                        'name': 'transactionLogDetail', 'value': this.state.transactionLogDetail
                    }, {
                        'name': 'transactionLogStreamErr',
                        'input': this.state.assetFilter,
                        'value': this.state.transactionLogStreamErr
                    }, {
                        'name': 'transactionLogStreamWarn',
                        'input': this.state.assetFilter,
                        'value': this.state.transactionLogStreamWarn
                    }, {
                        'name': 'transactionLogStreamInfo',
                        'input': this.state.assetFilter,
                        'value': this.state.transactionLogStreamInfo
                    }, {
                        'name': 'transactionLogStreamDetails',
                        'input': this.state.assetFilter,
                        'value': this.state.transactionLogStreamDetails
                    }, {
                        'name': 'traceRouteEnable', 'value': this.state.traceRouteEnable
                    }, {
                        'name': 'rvlUdpSrcPort', 'value': this.state.rvlUdpSrcPort
                    }, {
                        'name': 'rvlEthPort',
                        'input': this.state.rvlEthPort,
                        'value': true
                    }, {
                        'name': 'rvlAudioBind', 'value': this.state.rvlAudioBind
                    }, {
                        'name': 'rvlTimestampInsert', 'value': this.state.rvlTimestampInsert
                    }
                ];
            }
        } else {
            // If 'None' is selected for ethernet port, don't send the 'rvlEthPort' information.
            if (this.state.rvlEthPort === -1) {
                options = [
                    {
                        'name': 'transactionLogErr', 'value': this.state.transactionLogErr
                    }, {
                        'name': 'transactionLogWarn', 'value': this.state.transactionLogWarn
                    }, {
                        'name': 'transactionLogInfo', 'value': this.state.transactionLogInfo
                    }, {
                        'name': 'transactionLogDetail', 'value': this.state.transactionLogDetail
                    }, {
                        'name': 'traceRouteEnable', 'value': this.state.traceRouteEnable
                    }, {
                        'name': 'rvlUdpSrcPort', 'value': this.state.rvlUdpSrcPort
                    }, {
                        'name': 'rvlAudioBind', 'value': this.state.rvlAudioBind
                    }, {
                        'name': 'rvlTimestampInsert', 'value': this.state.rvlTimestampInsert
                    }
                ];
            } else {
                options = [
                    {
                        'name': 'transactionLogErr', 'value': this.state.transactionLogErr
                    }, {
                        'name': 'transactionLogWarn', 'value': this.state.transactionLogWarn
                    }, {
                        'name': 'transactionLogInfo', 'value': this.state.transactionLogInfo
                    }, {
                        'name': 'transactionLogDetail', 'value': this.state.transactionLogDetail
                    }, {
                        'name': 'traceRouteEnable', 'value': this.state.traceRouteEnable
                    }, {
                        'name': 'rvlUdpSrcPort', 'value': this.state.rvlUdpSrcPort
                    }, {
                        'name': 'rvlEthPort',
                        'input': this.state.rvlEthPort,
                        'value': true
                    }, {
                        'name': 'rvlAudioBind', 'value': this.state.rvlAudioBind
                    }, {
                        'name': 'rvlTimestampInsert', 'value': this.state.rvlTimestampInsert
                    }
                ];
            }
        }
        axios.post(url, {
            mode: 'modify',
            defaults: {
            },
            options: options
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.code === 'SUCCESS') {
                    Toast.info('Diagnostics configuration applied');
                } else {
                    Toast.error('Failed to update Diagnostics configuration');
                }

            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('updateConfig() error: ', error);
                Toast.error('Failed to update Diagnostics configuration');
            });
        this.fetchAssetVariants();
    }

    fetchEthernetPorts() {
        let _this = this;
        let url = 'http://default/api/config/section/options/abr';
        axios.post(url, {
            mode: 'get',
            options: [
                { 'name': 'rvlEthPortInst', 'input': 0 }, { 'name': 'rvlEthPortInst', 'input': 1 }, { 'name': 'rvlEthPortInst', 'input': 2 },
                { 'name': 'rvlEthPortInst', 'input': 3 }, { 'name': 'rvlEthPortInst', 'input': 4 }, { 'name': 'rvlEthPortInst', 'input': 5 },
                { 'name': 'rvlEthPortInst', 'input': 6 }, { 'name': 'rvlEthPortInst', 'input': 7 }, { 'name': 'rvlEthPortInst', 'input': 8 },
                { 'name': 'rvlEthPortInst', 'input': 9 }, { 'name': 'rvlEthPortInst', 'input': 10 }, { 'name': 'rvlEthPortInst', 'input': 11 },
                { 'name': 'rvlEthPortInst', 'input': 12 }, { 'name': 'rvlEthPortInst', 'input': 13 }, { 'name': 'rvlEthPortInst', 'input': 14 },
                { 'name': 'rvlEthPortInst', 'input': 15 }
            ]
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.section !== undefined) {
                    let responseObject = response.data.section.options;
                    let arr: any[] = [], options = [];
                    for ( let i = 0; i < responseObject.length; i++) {
                        if (responseObject[i].value !== 'disabled') {
                            arr.push({value: i, text: responseObject[i].value});
                        }
                    }

                    for (let key = 0; key < arr.length; key++) {
                       options.push({'name': 'rvlEthPort', 'input': arr[key].value});
                    }

                    _this.setState({
                        rvlPortOptions: arr
                    });

                    axios.post(url, {
                        mode: 'get',
                        options: options
                    })
                        .then(function (resp: AxiosResponse) {
                            let respObj = resp.data.section.options;
                            let portEnabled = false;
                            for (let j = 0; j < respObj.length; j++) {
                                // port enabled
                                if (respObj[j].value) {
                                    portEnabled = true;
                                    _this.setState({
                                        rvlEthPort: arr[j].value
                                    });
                                }
                            }
                            if (!portEnabled || respObj.length === 0) {
                                arr.push({value: -1, text: 'None'});
                            }
                        })
                        .catch(function (err: AxiosRequestConfig) {
                            // tslint:disable-next-line:no-console
                            console.log('rvlEthPort get() error: ', err);
                        });
                } else
                    // tslint:disable-next-line:no-console
                    console.log('expected array of config values, got ', response.data);
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('fetchData() error: ', error);
            });
    }

    render() {
        const rvlAudioOptions = [
            { value: 'disabled', text: 'Disabled'},
            { value: 'low', text: 'Low'},
            { value: 'high', text: 'High'}
        ];

        return (
        <OAuth.Context>
            {(oauth: OAuthClientStatus) => {
                return (
                    <React.Fragment>
                        <div className="assetAliasFilters">
                            <Label className="system-config-pageHeader">
                                Diagnostics
                            </Label>
                            <Button
                                floated="right"
                                className="rightButton"
                                content="Apply"
                                title="Update Config"
                                onClick={(e, data) => this.updateConfig(e, data)}
                            />
                        </div>
                        <div className="vertical-flex-main">
                        <Segment.Group className="system-config-segment">
                            <Segment className="segment-header">Transaction Log - Global</Segment>
                            <Segment>
                                <Form>
                                    <Form.Group grouped>
                                        <Label className="right-align-label">
                                            Errors
                                        </Label>
                                        <Checkbox
                                            className="config-checkbox"
                                            checked={this.state.transactionLogErr}
                                            onChange={(e: any, data: any) => this.setState({transactionLogErr: data.checked})}
                                        />
                                    </Form.Group>
                                    <Form.Group grouped>
                                        <Label className="right-align-label">
                                            Warnings
                                        </Label>
                                        <Checkbox
                                            className="config-checkbox"
                                            checked={this.state.transactionLogWarn}
                                            onChange={(e: any, data: any) => this.setState({transactionLogWarn: data.checked})}
                                        />
                                    </Form.Group>
                                    <Form.Group grouped>
                                        <Label className="right-align-label">
                                            Informational
                                        </Label>
                                        <Checkbox
                                            className="config-checkbox"
                                            checked={this.state.transactionLogInfo}
                                            onChange={(e: any, data: any) => this.setState({transactionLogInfo: data.checked})}
                                        />
                                    </Form.Group>
                                    <Form.Group grouped>
                                        <Label className="right-align-label">
                                            Details
                                        </Label>
                                        <Checkbox
                                            className="config-checkbox"
                                            checked={this.state.transactionLogDetail}
                                            onChange={(e: any, data: any) => this.setState({transactionLogDetail: data.checked})}
                                        />
                                    </Form.Group>
                                </Form>
                            </Segment>
                            {!oauth.VODOnlyLicensePresent &&
                            <Segment className="segment-header">Transaction Log - Per Stream</Segment>
                            }
                            {!oauth.VODOnlyLicensePresent &&
                            <Segment>
                                <Form>
                                    <Form.Group grouped>
                                        <Label className="right-align-label">
                                            Alias
                                        </Label>
                                        <Dropdown
                                            className="assetVariantDropDown"
                                            placeholder="----"
                                            search
                                            options={this.state.assetVariants}
                                            selection
                                            value={this.state.assetFilter}
                                            onChange={(event, data) => this.assetVariantChange(data.value)}
                                        />
                                    </Form.Group>
                                    <Form.Group grouped>
                                    <Label className="right-align-label-width275"/>
                                    <Label className="right-align-label-width">
                                        * - A preceding asterisk means the alias transaction log has been modified.
                                    </Label>
                                    </Form.Group>
                                    <Form.Group grouped>
                                        <Label className="right-align-label">
                                            Errors
                                        </Label>
                                        <Checkbox
                                            className="config-checkbox"
                                            checked={this.state.transactionLogStreamErr}
                                            onChange={(e: any, data: any) => this.setState({transactionLogStreamErr: data.checked})}
                                        />
                                    </Form.Group>
                                    <Form.Group grouped>
                                        <Label className="right-align-label">
                                            Warnings
                                        </Label>
                                        <Checkbox
                                            className="config-checkbox"
                                            checked={this.state.transactionLogStreamWarn}
                                            onChange={(e: any, data: any) => this.setState({transactionLogStreamWarn: data.checked})}
                                        />
                                    </Form.Group>
                                    <Form.Group grouped>
                                        <Label className="right-align-label">
                                            Informational
                                        </Label>
                                        <Checkbox
                                            className="config-checkbox"
                                            checked={this.state.transactionLogStreamInfo}
                                            onChange={(e: any, data: any) => this.setState({transactionLogStreamInfo: data.checked})}
                                        />
                                    </Form.Group>
                                    <Form.Group grouped>
                                        <Label className="right-align-label">
                                            Details
                                        </Label>
                                        <Checkbox
                                            className="config-checkbox"
                                            checked={this.state.transactionLogStreamDetails}
                                            onChange={(e: any, data: any) => this.setState({transactionLogStreamDetails: data.checked})}
                                        />
                                    </Form.Group>
                                </Form>
                            </Segment>}
                        </Segment.Group>
                        <Segment.Group className="system-config-segment">
                            <Segment className="segment-header">Trace Route</Segment>
                            <Segment>
                                <Form>
                                    <Form.Group grouped>
                                        <Label className="right-align-label">
                                            Enable Trace Route to Media Server
                                        </Label>
                                        <Checkbox
                                            className="config-checkbox"
                                            checked={this.state.traceRouteEnable}
                                            onChange={(e: any, data: any) => this.setState({traceRouteEnable: data.checked})}
                                        />
                                    </Form.Group>
                                </Form>
                            </Segment>
                        </Segment.Group>
                        {!oauth.VODOnlyLicensePresent ?
                        <Segment.Group className="system-config-segment">
                            <Segment className="segment-header">RVL</Segment>
                            <Segment>
                                <Form>
                                    <Form.Group grouped>
                                        <Label className="right-align-label">
                                            Ethernet Port
                                        </Label>
                                        <Dropdown
                                            search
                                            options={this.state.rvlPortOptions}
                                            selection
                                            value={this.state.rvlEthPort}
                                            onChange={(event: any, data: any) => this.setState({rvlEthPort: data.value})}
                                        />
                                    </Form.Group>
                                    <Form.Group grouped>
                                        <Label className="right-align-label">
                                            UDP Source Port
                                        </Label>
                                        <Input
                                            maxLength={9}
                                            value={this.state.rvlUdpSrcPort}
                                            onChange={(e: any, data: any) => this.setState({rvlUdpSrcPort: data.value})}
                                        />
                                    </Form.Group>
                                    <Form.Group grouped>
                                        <Label className="right-align-label">
                                            Audio Binding
                                        </Label>
                                        <Dropdown
                                            search
                                            options={rvlAudioOptions}
                                            selection
                                            value={this.state.rvlAudioBind}
                                            onChange={(event: any, data: any) => this.setState({rvlAudioBind: data.value})}
                                        />
                                    </Form.Group>
                                    <Form.Group grouped>
                                        <Label className="right-align-label">
                                            Timestamp Insert
                                        </Label>
                                        <Checkbox
                                            className="config-checkbox"
                                            checked={this.state.rvlTimestampInsert}
                                            onChange={(e: any, data: any) => this.setState({rvlTimestampInsert: data.checked})}
                                        />
                                    </Form.Group>
                                </Form>
                            </Segment>
                        </Segment.Group>
                        : null}
                        </div>
                    </React.Fragment>
                );
            }}
        </OAuth.Context>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/monitoring/diagnosticsConfig.tsx